import { createStyles, makeStyles } from '@mui/styles';
import { STYLE } from 'constants/style';

export const useStyles = makeStyles((theme: any) =>
  createStyles({
    modal: {
      '& .MuiDialog-paper': {
        width: '383px',
        maxWidth: '100%',
      },
    },
    otpInput: {
      marginTop: '22px',
      marginBottom: '22px',
      '@media (max-width: 768px)': {
        '& input': {
          fontSize: '22px !important',
        },
      },
      '@media (max-width: 500px)': {
        '& input': {
          fontSize: '20px !important',
        },
        '& .MuiBox-root': {
          gap: '12px !important',
        },
      },
    },
    verifyButton: {
      minWidth: '138px !important',
    },
  }),
);
